"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var formik_1 = require("formik");

var react_1 = __importDefault(require("react"));

var __1 = require("..");

var __2 = require("../..");

var AuthStyled_1 = require("../styled/AuthStyled");

var FormikConnected_1 = __importDefault(require("./FormikConnected"));

var ShortPersonalDetailsForm =
/** @class */
function (_super) {
  __extends(ShortPersonalDetailsForm, _super);

  function ShortPersonalDetailsForm() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ShortPersonalDetailsForm.prototype.render = function () {
    var _a = this.props,
        previousHandler = _a.previousHandler,
        activeBreakpoint = _a.activeBreakpoint,
        updating = _a.updating,
        handleSubmit = _a.handleSubmit,
        isValid = _a.isValid,
        isSubmitting = _a.isSubmitting;
    var buttonProps = {
      type: components_lib_1.ButtonTypeEnum.primary,
      text: __2.FieldPlaceHolders.signUp,
      onPress: handleSubmit,
      disabled: !isValid || updating
    };

    if (updating) {
      buttonProps.icon = {
        position: components_lib_1.ButtonIconPositionEnum.left,
        name: '',
        size: components_lib_1.IconSizeEnum.small,
        renderFunction: function renderFunction() {
          return react_1.default.createElement(components_lib_1.LoadingIndicator, {
            size: "small"
          });
        }
      };
    }

    return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(FormikConnected_1.default, {
      formik: __assign({}, this.props)
    }), react_1.default.createElement(AuthStyled_1.FormInputGroup, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
      placeholder: __2.FieldPlaceHolders.firstName,
      name: __2.FieldNames.firstName,
      isDisabled: isSubmitting,
      accessibilityLabel: 'Enter your first name'
    }, this.props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
      placeholder: __2.FieldPlaceHolders.lastInitial,
      maxLength: 1,
      name: __2.FieldNames.lastName,
      isDisabled: isSubmitting,
      accessibilityLabel: 'Enter your last initial'
    }, this.props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
      name: __2.FieldNames.nickName,
      label: __2.FieldLabels.nickName,
      isDisabled: isSubmitting,
      accessibilityLabel: 'Enter your nickname'
    }, this.props))), react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, this.props, {
      name: __2.FieldNames.preferredPronoun
    }), react_1.default.createElement(formik_1.Field, {
      component: components_lib_1.FormPicker,
      name: __2.FieldNames.preferredPronoun,
      label: __2.FieldLabels.preferredPronoun,
      type: components_lib_1.FormPickerComponent.type.singleSelect,
      options: core_1.preferredPronounValues,
      disabled: isSubmitting
    }))), react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, this.props, {
      name: __2.FieldNames.country
    }), react_1.default.createElement(formik_1.Field, {
      component: components_lib_1.FormPicker,
      name: __2.FieldNames.country,
      label: __2.FieldLabels.country,
      type: components_lib_1.FormPickerComponent.type.singleSelect,
      options: core_1.countryValues,
      disabled: isSubmitting
    }))), react_1.default.createElement(__1.AuthButtonsContainer, null, react_1.default.createElement(__1.StepButtonsWrapper, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(components_lib_1.Button, {
      type: components_lib_1.ButtonTypeEnum.link,
      text: __2.FieldLabels.back,
      uppercase: true,
      onPress: previousHandler,
      accessibilityLabel: __2.FieldLabels.back
    }), react_1.default.createElement(components_lib_1.Button, __assign({}, buttonProps, {
      uppercase: true
    })))));
  };

  return ShortPersonalDetailsForm;
}(react_1.default.Component);

exports.ShortPersonalDetailsForm = ShortPersonalDetailsForm;